import { foldUwContexts, LegacyUwQuestionnaire, MigratedProductUw } from '@ps20-frontend/migrations';
import {
  CheckoutProduktPreV26,
  CheckoutProduktV26,
  LegacyCheckoutUwFragebogen,
  StatePreV26,
  StateV26,
} from './26_migrate_uw_contexts.interface';

const toLegacyQuestionnaire = (
  fragebogen: LegacyCheckoutUwFragebogen | undefined,
): LegacyUwQuestionnaire | undefined => {
  if (!fragebogen) {
    return undefined;
  }
  return {
    files: fragebogen.files ?? [],
    comment: fragebogen.comment,
    uwDecision: fragebogen.uwDecision,
    underwriterName: fragebogen.underwriterName,
    underwriterBensl: fragebogen.underwriterBensl,
  };
};

const hasOutbuildingEvidence = (
  fragebogen: LegacyCheckoutUwFragebogen | undefined,
): boolean =>
  fragebogen?.uwDecision !== undefined || (fragebogen?.files?.length ?? 0) > 0;

const migrateProdukt = (produkt: CheckoutProduktPreV26): CheckoutProduktV26 => {
  const { elementarUwfragebogen, nebengebaeudeUwfragebogen, ...rest } = produkt;

  const uw: MigratedProductUw | undefined = foldUwContexts({
    uw: produkt.uw,
    naturalHazards: toLegacyQuestionnaire(elementarUwfragebogen),
    outbuilding: toLegacyQuestionnaire(nebengebaeudeUwfragebogen),
    showElementarfragebogen: Boolean(elementarUwfragebogen),
    showNebengebaeude: hasOutbuildingEvidence(nebengebaeudeUwfragebogen),
  });

  return uw ? { ...rest, uw } : { ...rest };
};

export const migrateCheckoutUwContexts = (
  previousState: StatePreV26,
  newVersion: number,
): StateV26 => {
  const migratedState: StatePreV26 = {
    ...previousState,
    version: newVersion,
    produkte: previousState.produkte.map(migrateProdukt),
  };
  delete migratedState.elementarfragebogen;
  return migratedState as StateV26;
};
